export enum TaskStatusEnum {
  New = 'New',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Cancelled = 'Cancelled'
}
